@if (!erreurRecuperation()) {
  <div class="config-donnes-analyse">
    @if (tabConfig().length> 0) {
      <app-grid-list-kpi [listeObjets]="tabConfig()"
        [proprietesAffichees]="proprietesAfficheesConfig" [configeView]="true" [siteCurrency]="siteCurrency">
      </app-grid-list-kpi>
    }
    <div>
      <form class="form-inline" (ngSubmit)="onSubmit()">
        <label for="selectProfil"
        class="col-form-label mr-2">{{'CONFIGURATION_DONNEES.ASSIGNER_PROFIL' | translate}}</label>
        <ng-select [items]="tabProfils()" [multiple]="false" [closeOnSelect]="true" [searchable]="true" bindLabel="nom"
          placeholder="{{'MODALE_SITE.PROFIL' | translate}}" name="selectProfil" id="selectProfil"
          [(ngModel)]="profilSelectionne" (change)="changerProfil()" [virtualScroll]="true" class="mr-2 col-md-2"
          style="min-width:200px;">
        </ng-select>
        <div class="form-group">
          <button type="submit" class="btn btn-outline-success" style="margin-right:10px;"
          [disabled]="!profilSelectionne">{{'GLOBAL.VALIDER' | translate}}</button>
          <button type="button" class="btn btn-secondary" (click)="annulModif()"
          [disabled]="!profilSelectionne">{{'GLOBAL.ANNULER' | translate}}</button>
        </div>
      </form>
    </div>
  </div>
}
@if (erreurRecuperation()) {
  <div class="custom-alert custom-alert-sm">
    {{'GLOBAL.ERREUR_RECUP_DONNEES' | translate }}
  </div>
}